import { action } from 'easy-peasy';
import { IActionAddTemplate } from '../types';

const addTemplate: IActionAddTemplate = action((state, payload) => {
  state.items = [payload, ...state.items];
});

export default addTemplate;
